import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Toaster } from '@/components/ui/toaster'
import { AuthProvider } from '@/contexts/AuthContext'
import AddProductPage from '@/pages/AddProductPage'
import AddStaticPagePage from '@/pages/AddStaticPagePage'
import ActivitiesPage from '@/pages/ActivitiesPage'
import CategoriesPage from '@/pages/CategoriesPage'
import CategoryDetailPage from '@/pages/CategoryDetailPage'
import ClientsPage from '@/pages/ClientsPage'
import DashboardPage from '@/pages/DashboardPage'
import EditStaticPagePage from '@/pages/EditStaticPagePage'
import HeroSlidesPage from '@/pages/HeroSlidesPage'
import LoginPage from '@/pages/LoginPage'
import OrderDetailPage from '@/pages/OrderDetailPage'
import OrdersPage from '@/pages/OrdersPage'
import ProductDetailPage from '@/pages/ProductDetailPage'
import ProductsPage from '@/pages/ProductsPage'
import ReviewsPage from '@/pages/ReviewsPage'
import SettingsPage from '@/pages/SettingsPage'
import StaticPagesPage from '@/pages/StaticPagesPage'
import TestimonialsPage from '@/pages/TestimonialsPage'
import UsersPage from '@/pages/UsersPage'
import VouchersPage from '@/pages/VouchersPage'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/activities" element={<ActivitiesPage />} />
                    <Route path="/clients" element={<ClientsPage />} />
                    <Route path="/hero-slides" element={<HeroSlidesPage />} />
                    <Route path="/categories" element={<CategoriesPage />} />
                    <Route path="/categories/:id" element={<CategoryDetailPage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/products/add" element={<AddProductPage />} />
                    <Route path="/products/:id" element={<ProductDetailPage />} />
                    <Route path="/orders" element={<OrdersPage />} />
                    <Route path="/orders/:id" element={<OrderDetailPage />} />
                    <Route path="/vouchers" element={<VouchersPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/reviews" element={<ReviewsPage />} />
                    <Route path="/testimonials" element={<TestimonialsPage />} />
                    <Route path="/static-pages" element={<StaticPagesPage />} />
                    <Route path="/static-pages/add" element={<AddStaticPagePage />} />
                    <Route path="/static-pages/:id" element={<EditStaticPagePage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster />
      </Router>
    </AuthProvider>
  )
}

export default App
